import React from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../provider/AuthProvider';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ component: Component }) => {
    const { token } = useAuth();
    const location = useLocation();
    const from = `${location.pathname}${location.search}${location.hash}`;
    return token ? <Component /> : <Navigate to="/login" state={{ from }} replace />;
};


PrivateRoute.propTypes = {
    component: PropTypes.elementType.isRequired,
};

export default PrivateRoute;
